import { impactStats } from "@/mocks/home";

export default function ImpactStats() {
  return (
    <section className="relative w-full bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 -mt-10 relative z-10">
          {impactStats.map((stat) => (
            <div
              key={stat.id}
              className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-7 text-center"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto rounded-full bg-primary-100 text-primary-700 mb-3">
                <i className={`${stat.icon} text-xl md:text-2xl`}></i>
              </span>
              <p className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
                {stat.value}
              </p>
              <p className="mt-1 text-xs md:text-sm text-foreground-600">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}